module.exports = "/assets/dist/images/sedan_wide.jpg?cd37af969308d4a93941d7fb45404669";